import React from "react";
import { ReactNode, isValidElement } from "react";
import { ContentModal } from "~components";

interface ErrorModalProps {
  error?: {
    title: string;
    message: string | ReactNode;
  };
  onClose: () => void;
}

export const ErrorModal = ({ error, onClose }: ErrorModalProps) => {
  if (!error) return null;

  return (
    <ContentModal
      isOpen={!!error}
      setIsOpen={onClose}
      title={error?.title ?? ""}
    >
      {typeof error?.message === "string" ? (
        <div>{error.message}</div>
      ) : isValidElement(error.message) ? (
        React.cloneElement(error.message)
      ) : (
        <div>Invalid error message</div>
      )}
    </ContentModal>
  );
};
